
import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon'

export const UnderObservationIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} viewBox="0 0 20 20" fill="2" >
            <circle cx="9.99512" cy="10" r="7" stroke="#FF3B2F" strokeWidth="2" />
            <circle cx="9.99512" cy="10" r="2" fill="#FF3B2F" />
            <line x1="9.99512" y1="4" x2="9.99512" y2="1" stroke="#FF3B2F" strokeWidth="2" strokeLinecap="round" />
            <line x1="9.99512" y1="19" x2="9.99512" y2="16" stroke="#FF3B2F" strokeWidth="2" strokeLinecap="round" />
            <line x1="4" y1="10" x2="1" y2="10" stroke="#FF3B2F" strokeWidth="2" strokeLinecap="round" />
            <line x1="18.9951" y1="10" x2="15.9951" y2="10" stroke="#FF3B2F" strokeWidth="2" strokeLinecap="round" />
        </SvgIcon>
  )
}
